import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../builder';
import { InViewTracking } from './InViewTracking';

export default createBuilderModule(withChildren(InViewTracking), {
  name: 'InViewTracking',
  image: 'https://cdn.zappy.app/a26168b9b480805722e50990a838c47c.png',
  inputs: [
    {
      name: 'sectionName',
      type: 'string',
      required: true,
    },
  ],
  childRequirements: {
    message:
      'Children of the In View Tracking component must be a built-in component from the Basics section',
    query: {
      'component.name': {
        $in: [
          'Core:Button',
          'Core:Text',
          'Core:Image',
          'Core:Columns',
          'Core:Box',
          'Core:Section',
        ],
      },
    },
  },
});
